<div class="row ms-2 me-2 mt-1 mb-1" *ngIf="batteryTypes.length > 0">
  <div class="col-md-3 ps-1 pe-1 d-flex align-items-center justify-content-center">
    <rb-form-select-list
      #batteryTypeSelector
      class="battery-type-selector"
      [iconClass]="'rb-ic-search'"
      [itemList]="batteryTypes"
      [valueIdSelector]="'batteryType'"
      [labelIdSelector]="'label'"
      [(ngModel)]="selectedBatteryTypes"
      [placeholder]="'Type to search a fleet...'"
      (ngModelChange)="onBatteryTypeSelected($event)"
    ></rb-form-select-list>
  </div>
  <div class="col-md-9 ps-1 pe-1 pb-2 d-flex align-items-center">
    <div *ngFor="let batteryType of selectedBatteryTypes; let i = index" [ngClass]="['chip-color-' + (i % 3 + 1)]"
    class="a-chip fleet-chip ps-3">
      {{ batteryType?.label }}
      <span *ngIf="selectedBatteryTypes.length === 1" class="chip-spacer"></span>
      <button *ngIf="selectedBatteryTypes.length > 1" class="close-btn rb-btn rb-passive-link" (click)="batteryTypeSelector.removeSelectedItem(batteryType)">
        <i class="rb-ic rb-ic-close-small" title="close"></i>
      </button>
    </div>
  </div>
</div>
<div class="row ms-2 me-2 mt-1 mb-1" *ngIf="batteryTypesLoadingError">
  <div class="col-md-12 ps-1 pe-1">
    <rb-callout type="warning">
        No fleets found!
    </rb-callout>
  </div>
</div>

<div class="row ms-0 me-0 mt-1 mb-1">
  <rb-tab-panel class="full-width ps-0 pe-0 ms-0 me-0">
    <div *rbTabPanelItem="'General'" class="content">
      <app-general-fleet *ngIf="fleetId.length > 0" [fleetId]="fleetId" [selectedBatteryTypes]="selectedBatteryTypes" [companyData]="companyData" [isMetric]="isMetric"></app-general-fleet>
    </div>
    <div *rbTabPanelItem="'Charging'" class="content">
      <app-charging-fleet *ngIf="fleetId.length > 0" [fleetId]="fleetId" [selectedBatteryTypes]="selectedBatteryTypes"></app-charging-fleet>
    </div>
    <div *rbTabPanelItem="'Duty Cycle'" class="content">
      <app-dutycycle-fleet *ngIf="fleetId.length > 0" [fleetId]="fleetId" [selectedBatteryTypes]="selectedBatteryTypes" [companyData]="companyData" [isMetric]="isMetric"></app-dutycycle-fleet>
    </div>
  </rb-tab-panel>
</div>